export default __webpack_public_path__ + "static/media/PPI-pools-023.b60e277a.jpg";